import { adminHttpClient } from '../../commons/adminHttpClient'

export type InviteIchraEmployeesRequest = {
  notificationDate: string
  planPeriodStartDate: string
}

const inviteIchraEmployees = (values: InviteIchraEmployeesRequest): Promise<any> => {
  return adminHttpClient.put('/Benefit/InviteIchraEmployees', values)
}

export default inviteIchraEmployees
